import React from 'react'
import {TextButton} from 'wix-ui-tpa/cssVars'

import {classes, st} from './index.st.css'

type ErrorMessageProps = {
  message: string
  onClick?: () => void
  className?: string
}

export const ErrorMessage = ({message, onClick, className}: ErrorMessageProps) => {
  return (
    <div className={classes.root}>
      <TextButton role="alert" onClick={onClick} className={st(classes.error, className)}>
        {message}
      </TextButton>
    </div>
  )
}
